<template>
  <v-container fluid>
    <v-dialog v-model="dialog" max-width="900px" persistent>
      <v-card outlined>
        <v-card-title class="subtitle-1 font-weight-bold">
          Validar WebHook
          <v-spacer />
          <v-btn icon @click="dialog = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0 mb-0">
          <v-text-field
            label="Verify Token"
            v-model="config.verifyToken"
            outlined
            hide-details
            dense
          />
        </v-card-text>

        <v-card-actions class="">
          <v-spacer />
          <v-btn color="primary" small @click="updateKey"> Actualizar </v-btn>
          <v-btn text @click="dialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "WebhookValidation",
  data() {
    return {
      config: {
        verifyToken: "",
      },

      dialog: false,
      response: null,
      error: null,
    };
  },
  methods: {
    updateKey() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "/api/MetaAPI/verify-token",
          {
            token: this.config.verifyToken,
          },
          configuracion
        )
        .then((res) => console.log(res))
        .catch((err) => console.error(err));
    },
    open() {
      this.dialog = true;
    },
  },
};
</script>


    